import { PapiDeviation } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { MediaSrcFile } from '../../utils/DeviationMediaService/types';
import MediaService, { fallbackToLargestFile } from '../../utils/DeviationMediaService';
import { getCoverImageFile } from '../Thumb/helpers';

export const COVER_IMAGE_AS_BACKGROUND_DEFAULT_PROPS = {
  backgroundRepeat: 'no-repeat',
  backgroundPositionX: 'center',
  backgroundPositionY: 'center',
  backgroundSize: 'cover',
};

export type BackgroundStyleProp = Pick<
  React.CSSProperties,
  | 'backgroundImage'
  | 'backgroundRepeat'
  | 'backgroundPositionX'
  | 'backgroundPositionY'
  | 'backgroundSize'
>;

export function useDeviationCoverImage({
  deviation,
  width,
  height,
  allowHuge,
}: {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  allowHuge?: boolean;
}): {
  coverImage?: MediaSrcFile;
  asBackgroundStyleProp?: BackgroundStyleProp;
} {
  const cover_attachment = useFlag('cover_attachment');
  const coverImage: MediaSrcFile = cover_attachment
    ? MediaService.getSmallestThumbThatFullyCovers(
      deviation,
      width,
      height,
      fallbackToLargestFile,
      {
        allowPreview: allowHuge,
        allowFullview: allowHuge,
      }
    )
    : getCoverImageFile({
      deviation,
      width,
      height,
      allowHuge: allowHuge,
    });

  const style: BackgroundStyleProp = coverImage
    ? getCoverImageAsBackgroundStyleProp(coverImage.src)
    : undefined;
  return { coverImage, asBackgroundStyleProp: style };
}

export const getCoverImageAsBackgroundStyleProp = (src: string): BackgroundStyleProp => ({
  ...COVER_IMAGE_AS_BACKGROUND_DEFAULT_PROPS,
  backgroundImage: `url('${src}')`,
});
